'use strict';

document.addEventListener('DOMContentLoaded', function () {
  var swiper = new Swiper('.js-shopSlider', {
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.js-collectionPagenation',
      type: 'fraction'
    }
  });
});